import React from 'react';
import PropTypes from 'prop-types';
import styled from "@emotion/styled";


const ButtonWrapper = styled.button`
    width: 92px;
    height: 36px;
    
    /* default/shade/white */
    background: ${props => props.disabled ? 'rgba(118,118,117,0.28)' : 'var(--white)'};
    /* default/gray/400 */
    border: 1px solid #CBD5E0;
    box-sizing: border-box;
    border-radius: 5.14286px;
    user-select: none;
    cursor:pointer;
    
    
    background-position: center;
    transition: background 0.8s;
    
    :hover {
      background: rgba(118,118,117,0.28) radial-gradient(circle, transparent 1%, rgba(118,118,117,0.17) 1%) center/15000%;
    }
    
    :active {
      background-color: #767675;
      background-size: 100%;
      transition: background 0s;
    }
    
    :focus {
        outline: none
    }
    
`;

function ActionButton2(props) {
    return (
        <ButtonWrapper onClick={props.onClick}  disabled={props.disabled}>
            {props.children}
        </ButtonWrapper>
    );
}

ActionButton2.propTypes = {};
ActionButton2.defaultProps = {};

export default ActionButton2;
